<template>
  <!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
  <div>
    <!-- <div class="box-header-table text-right mb-3 d-flex justify-content-end gap-3">
      <Button label="Update status" :disabled="list_select_id.length == 0" @click="actionUpdateStatus" />
    </div> -->
    <div class="box-header-table simple-filter">
    <div class="filter-left">
      <div class="filter-item">
        <label>Total number of vehicles fixing</label>
        <Calendar
          v-model="filterDateRange"
          selectionMode="range"
          dateFormat="yy-mm-dd"
          :showIcon="true"
          :showButtonBar="true"
          :manualInput="false"
          appendTo="body"
          placeholder="From - To"
          @clear-click="applyHeaderFilters"
          @date-select="applyHeaderFilters"
        />
      </div>

      <div class="filter-item">
        <label>License plate number</label>
        <MultiSelect
        v-model="filterCarForRentIds"
        :options="licensePlateOptions"
        optionLabel="label"
        optionValue="value"
        dataKey="value"
        placeholder="All"
        :showClear="true"
        :filter="true"
        display="chip"
        appendTo="body"
        @change="applyHeaderFilters"
      />

      </div>
  </div>

  <div class="filter-right">
    <Button class="style_btn_export" label="Export" @click="export_excel"></Button>
  </div>
</div>

    <div class="row header-dashboard-custom">
    <div class="col-8" style="margin-bottom: 10px; margin-top: 10px;">
        <!-- <div class="card rental-card-custom"> -->
        <StatsCards
          type="fixed"
          :items="fixedItems"
        />
        <!-- </div> -->
      </div>
  </div>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :first="firstRecordIndex"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getBodyStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 40px; heigth: 40px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl' && view_club ==true"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectListClub(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectListClub(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>

        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'CheckToggleSelect'"  >
              <img v-if="slotProps.data.is_send_notification"  @click="click_icon_toggle(slotProps.data,false)" src="/assets/images/icon/active_toggle.png">
              <img v-else  @click="click_icon_toggle(slotProps.data,true)" src="/assets/images/icon/unactive_toggle.png">
<!--              <Checkbox   v-model="list_select_item" :value="slotProps.data.code" @change="process_change_checkbox_item()" />-->
            </div>
            <div v-if="c.custom == 'CheckBoxSelect'"  >
              <img v-if="list_select_id.indexOf(slotProps.data.id) != -1"  @click="remove_click(slotProps.data)" src="/assets/images/icon/icon_check_active.svg">
              <img v-else  @click="click_icon(slotProps.data)" src="/assets/images/icon/ic_check_record.svg">
<!--              <Checkbox   v-model="list_select_item" :value="slotProps.data.code" @change="process_change_checkbox_item()" />-->
            </div>
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>


      </template>
      <template v-if="c.filter" #filter>
        <div v-if="c.custom">
          <div v-if="c.custom == 'CheckBoxSelect'">
          <img  v-if="checkBoxAll == true" @click="click_icon_all(false)" src="/assets/images/icon/icon_check_active.svg">
          <img v-else  @click="click_icon_all(true)" src="/assets/images/icon/ic_check_record.svg">
          </div>
<!--          <img  @click="click_icon(slotProps.data)" src="/assets/images/icon/ic_check.svg">-->
<!--        <Checkbox v-if="c.custom == 'CheckBoxSelect'"  v-model="checkBoxAll" :binary="true" @change="process_change_checkbox_all($event)" />-->
        </div>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"

          @change="onFilter($event,c.filter.type,c.key)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd" 
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
          
          <Calendar
          v-if="c.filter.type == 'Date'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearDOB"
          dateFormat="yy-mm-dd" 
          :placeholder="$CoreService.getFilterPlaceHolder(c)"
          v-model="filters[getField(c)]"
          class="p-column-filter calendar-light-btn"
          :showIcon="true"
          selectionMode="single"
          appendTo="body"
          :showClear="true"
          :maxDate="new Date()"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center; justify-content: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        
        <div class="style-action-click">
          <Button
              v-for="(a, k) in actions.rows(slotProps.data)"
              :key="k"
              type="button"
              :icon="getIcon(a.icon)"
              :class="getClass(a.name)"
              :disabled="getDisabled(a.disabled)"
              style="margin: 2px"
              v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
        </div>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>

  <Dialog
        header="Update Status"
        :visible.sync="showUpdateStatusDialog"
        :contentStyle="{ overflow: 'visible' }"
        :modal="true"
    >

      <!-- Chọn status -->
      <label style="padding-left: 0px;" class="class-bold1 p-col-fixed txt-right">Car status</label>
      <v-select
        :clearable="false"
        class=""
        placeholder="Choose"
        v-model="status_update"
        :options="$constants.CAR_FOR_RENT_STATUS"
        :reduce="(item) => item.value"
        label="label"
      >
        <span slot="no-options" @click="$refs.select.open = false">
          Empty data
        </span>
      </v-select>
      <template #footer>
        <Button
            label="Cancel"
            @click="showUpdateStatusDialog = false"
            icon="pi pi-times"
            class="p-button-warning"
        />
        <Button
            label="Confirm"
            @click="updateStatusMulti()"
            icon="pi pi-check"
            class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
//import ApiRepository from "@/core/ApiRepository";
import StatsCards from "@/components/StatsCards.vue";  

import ApiRepository from "@/core/ApiRepository";

export default {
   components: {
      StatsCards,
  },
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
    // view_club:Boolean ,
  },
  data() {
    return {
    filterDateRange: null,          // thêm (đang thiếu)
 filterCarForRentIds: [],   // array
licensePlateOptions: [],
list_car_for_rent_id: [],

      status_update: null,
      showUpdateStatusDialog: false,
      filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filtersCustom: [],
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
      yearRange : (new Date().getFullYear() - 100)+":"+(new Date().getFullYear() + 100),
      yearDOB : (new Date().getFullYear() - 100)+":"+new Date().getFullYear(),
      time_zone_local : moment.tz.guess(true),
      view_club : false,
      list_select_id : [],
      list_map_id : {},
      checkBoxAll : false,//
      summaryItems: [
      {
        key: "need",
        icon: require("@/assets/car-ready.png"),
        text: "Fixing times",
        total: 70,
        bgColor: "#FFF6C8",
        circleColor: "rgba(0,0,0,0.06)",
      },
      {
        key: "done",
        icon: require("@/assets/car-available.png"),
        text: "Total",
        total: 68,
        bgColor: "#D9F0FB",
        circleColor: "#CBE9F7"
      }
    ],
    fixedItems: [
       {
        key: "fixTimes",
         icon: require("@/assets/car-fixing.png"),
        total: 0,
        text: "Fixing times",
        bgColor: "#FFF6C8",
        circleColor: "rgba(0,0,0,0.06)",
        span: 1   // 1/3
      },
      {
        key: "total",
       icon: require("@/assets/fix_price.png"),
        total: "$0",
        text: "Total",
        bgColor: "#DDF7EF",
        circleColor: "rgba(0,0,0,0.06)",
        span: 2   // 2/3
      }
    ]
    };
    
  },
  async created() {
    var year = new Date().getFullYear()
    var yearRange = (year-10)+':'+(year+90);
    var yearDOB = (year-100)+':'+year;
    this.yearRange = yearRange+'';
    this.yearDOB = yearDOB+'';
    this.test = this.tableData;
    var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CAR_ACCIDENT);
    // console.log('role_clubrole_club',arr_role_clubs)
    if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0){
      this.view_club = false;
    }else{
      this.view_club = true;
    }
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    /*
    * stateStorage="session"
    stateKey="dt-state-demo-session"
    * phai them thuoc tinh nay vao table
    * */
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
        /*if (this.lazyParams){
          this.filters = (this.lazyParams.filters) ? this.lazyParams.filters : {};
        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();

    this.loadCarsForFilter();

  },
  methods: {
    async loadCarsForFilter() {
  try {
    var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
    const list = await this.$CoreService.getListCarForRent(where_key);
    this.list_car_for_rent_id = list?.list || [];

    // options dropdown: label = biển số, value = id
    this.licensePlateOptions = (this.list_car_for_rent_id || []).map(x => ({
  label: x.license_plate_number,
  value: x.id
}));

  } catch (e) {
    console.log("loadCarsForFilter error", e);
  }
},

   buildLicensePlateOptions() {
  const set = new Set((this.listDataService || []).map(x => x.license_plate_number).filter(Boolean));
  this.licensePlateOptions = [{ label: "All", value: null }].concat(
    Array.from(set).map(v => ({ label: v, value: v }))
  );
},
async applyHeaderFilters() {
  // fixing_date_text
  if (this.filterDateRange?.[0] && this.filterDateRange?.[1]) {
    this.filtersCustom["fixing_date_text"] = 
    await this.$CoreService.convertFilter("DateRange","fixing_date_text",{fixing_date_text:this.filterDateRange});
  } else {
    this.filtersCustom["fixing_date_text"] = null;
  }

  // car_for_rent_id (MultiSelect ids)
  const idsRaw = Array.isArray(this.filterCarForRentIds) ? this.filterCarForRentIds : [];
  const ids = [...new Set(idsRaw.filter(Boolean))]; // remove null/undefined + dedupe

  this.filtersCustom["car_for_rent_id"] = ids.length ? { value: ids } : null;

  this.lazyParams.first = 0;
  this.onLazyEvent();
},




    async export_excel() {
  const that = this;
  try {
    const currentTimezone = moment.tz.guess();
    const headers = {
      Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
      Timezone: currentTimezone,
    };

    // ✅ Build request export từ filter hiện tại
    const dataRequest = {
  ...(this.data_filter || {}),
  is_sumary: true,
  is_excel: true,
  offset: null,
  limit: null,
};

    this.$commonFuction.is_loading(true);

    // ✅ gọi API export Fixing Car (BE mới)
    const item_res = await ApiRepository.post(
      "/api_admin/order/export_accident_admin",
      dataRequest,
      { headers }
    );

    const key_file = item_res?.data?.data?.key_file || null;
    if (!key_file) {
      this.$commonFuction.is_loading(false);
      alert("Export failed: missing key_file");
      return false;
    }

    let is_process = 0;
    const callData = window.setInterval(async () => {
      if (is_process === 1) return;
      is_process = 1;

      try {
        const headers2 = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
        };

        // ✅ check status dùng chung endpoint
        const resCheck = await ApiRepository.post(
          "/api_admin/need_to_pay/check-export-excel-status",
          { key_file },
          { headers: headers2 }
        );

        const item_check = resCheck?.data?.data || null;
        if (!item_check) {
          is_process = 0;
          return;
        }

        const key_process = item_check.process;

        if (key_process === "DONE") {
          const urL_report = item_check.urL_report;

          const dataResponseDownload = await this.$CoreService.callApiDownloadPost(
            "/_api/common/read_file_url",
            { file_url: urL_report },
            {}
          );

          const url = URL.createObjectURL(
            new Blob([dataResponseDownload.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );

          const link = document.createElement("a");
          link.href = url;

          const file_excel =
            "Fixing_car_" +
            moment().format("DDMMYYYY") +
            "_" +
            moment().format("HHmmss") +
            ".xlsx";

          link.setAttribute("download", file_excel);
          document.body.appendChild(link);
          link.click();

          clearInterval(callData);
          this.$commonFuction.is_loading(false);
          alert("Xuất dữ liệu thành công");
          return;
        }

        if (key_process === "ERROR") {
          clearInterval(callData);
          this.$commonFuction.is_loading(false);
          alert("Vui lòng thử lại");
          return;
        }

        // PENDDING -> tiếp tục poll
        is_process = 0;
      } catch (err) {
        clearInterval(callData);
        this.$commonFuction.is_loading(false);
        that.$toast.add({
          severity: "error",
          summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
          detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
          life: 3000,
        });
        console.log(err);
      }
    }, 2000); // ✅ poll nhanh hơn 2s

    return true;
  } catch (err) {
    this.$commonFuction.is_loading(false);
    that.$toast.add({
      severity: "error",
      summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
      detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
      life: 3000,
    });
    console.log(err);
    return false;//
  }
},

    updateStatusMulti(){
      //check bắt buộc chọn
      if (this.$commonFuction.isEmpty(this.status_update)){
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Please select at least one item', life: 3000 })
        return;
      }
      this.$commonFuction.is_loading(true);
      let variables = {
        'data_update': {
          'status': this.status_update
        },
        'where_key': {
          'id': {'_in': this.list_select_id}
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('car_for_rent'),
        variables: variables
      }).then(async (res) => {
        console.log('Success',res);
        
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
        that.showUpdateStatusDialog = false;
        this.onLazyEvent();
      }).catch(async error => {
        console.log('error', error);
        this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
        });
        this.$commonFuction.is_loading(false);
    })
      this.$commonFuction.is_loading(false);
    },
    actionUpdateStatus(){
      this.showUpdateStatusDialog = true;
    },
    click_icon(data){
      this.list_select_id.push(data.id)
      this.process_emit_check_box()
    },
    remove_click(data){
       this.checkBoxAll =false;
      var list_id = []
      for (var i = 0 ; i < this.list_select_id.length ; i++){
        if (data.id != this.list_select_id[i]){
          list_id.push(this.list_select_id[i])
        }
      }
      this.list_select_id = list_id
      this.process_emit_check_box()
    },
    async click_icon_toggle(data, is_active) {
      const actionText = is_active ? "enable" : "disable";
      if (confirm(`Are you sure you want to ${actionText} Send notification?`)) {
        let variables = {
          'data_update': {
            'is_send_notification': is_active
          },
          'where_key': {
            'id': {'_eq': data.id}
          }
        }
        await this.$apollo.mutate({
            mutation: DataServices.updateData('care_reminder'),
            variables: variables
        }).then(async (res) => {
            // console.log("res",res);
            if (res.data[Object.keys(res.data)].affected_rows) {
             data.is_send_notification = is_active;
            }
        }).catch(async error => {
            console.log('error', error);
            this.$toast.add({
                severity: 'error',
                summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
                life: 3000
            });
        });
      }
    },

    click_icon_all(is_active){
      this.checkBoxAll = is_active
      var list_id = []
     if (this.checkBoxAll == true){

       for (var i = 0 ; i< this.listDataService.length ; i++){

         list_id.push(this.listDataService[i].id)
         console.log("saiwqwqw",this.listDataService[i].id)
       }
       console.log("list_order_code",list_id)
       this.list_select_id = list_id

     }
     else {
       console.log("saksaksa")
       this.list_select_id = []
     }
      this.process_emit_check_box()
      console.log("checkBoxAll",this.checkBoxAll)
    },
    process_emit_check_box(){
      var obj = {
        list_select_item:this.list_select_id,
        list_map_id:this.list_map_id,
      }
      this.$emit("action-list_select_item", obj);
    },
    onRowSelect(event) {
      this.$emit('onRowSelect', event.data);
    },
    redirectListClub(data, e) {
      let clickedElId = e.target.id
      console.log(data.id)
      if (clickedElId === 'list-users-clubs') {
        var id = data.id;
        var path = `/admin/list-users_clubs/${id}`;
        this.$router.push({path: path})
      }
    },
    callbackCustomUrl(c,data){
      var text = ''
      switch(c.key) {
        case 'club_html':
          if(data.view_users_clubs_expiration_aggregate && data.view_users_clubs_expiration_aggregate.aggregate){
            var count_club = data.view_users_clubs_expiration_aggregate.aggregate.count
            if(this.view_club == true){
              text = '<a class="txt-link" id="list-users-clubs" :data-id="'+data.id+'">'+count_club+'</a>';
            }else{
              text = count_club; 
            }
          }else{
            text = 0;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "text-align:center;";
      if (col.width) style += "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style += "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style += "width: 6em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "text-align:center; width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      // console.log("this.options:",this.options)
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("LL");
        // value = moment.tz(row[col.key], this.time_zone_local).format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("ll HH:mm");
        // value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], this.time_zone_local).format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          // console.log("col.models:",col.models);
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn`;
      } else if (col.filter.type == "input") {
        return `Input`;
      } else if (col.filter.type == "DateRange") {
        return `Choose`;
      } else if (col.filter.type == "Date") {
        return `Choose`;
      } else {
        return ``;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    callbackDataSelect(c,data){
      var list_status = this.$constants.LIST_STATUS_RENTAL_ORDER;
      var map_status = { }
      //$constants.CAR_FOR_RENT_STATUS
      for (const [key__1, value] of Object.entries(list_status)) {
        console.log("key__1",key__1)
        map_status[value.value] = value.label;
      }
      console.log("sasasawqwqfdf")
      var text = "";
      switch(c.key) {
          // key la cai name
        case 'active':
          if(data.active == true){
            text = `<i style="color: green" class="pi pi-check icon"></i>`;
          }else{
            text = `<i style="color: red" class="pi pi-times icon"></i>`;
          }
          break;
        case 'status_car':
          console.log("data.booking_status",data)
          var status = data?.car_status;
          if(!this.$commonFuction.isEmpty(status)){
            text = this.$constants.CAR_FOR_RENT_STATUS.find(s => s.value === status)?.label ?? '';
          }
          break;

        default:
      }
      return text;
    },
 async dataList(lazyParams) {
      //console.log('lazyParams');
      //console.log('lazyParams:',lazyParams);
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
     // console.log("this.model.tableName:",this.model.tableName)
      // var gqLQueryList = DataServices.getList(this.model.tableName);
      var where = {};
      var filters = lazyParams.filters;
      //console.log("filtersfilters11:",filters)
      var dataRequest = {
        //  filters: [],
        offset:offset,
        limit:limit,
      };
      if (filters) {
  for (const [key, value] of Object.entries(filters)) {
    if (value == null) continue;          // ✅ FIX crash
    dataRequest[key] = value;

    // đoạn dưới chỉ chạy khi value có tồn tại
    if (!this.$commonFuction.isEmpty(value.value)) {
      if (value.type_input == "input") {
        if (key == "fullname") {
          where["plain_fullname"] = { _like: "%" + this.$commonFuction.SkipVN(value.value) + "%" };
        } else {
          where[key] = { _like: "%" + value.value + "%" };
        }
      } else if (value.type_input == "select") {
        if (key == "name_group_filter") {
          where["group_id"] = { _eq: value.value };
        }
      }
    }
  }
}

      /*
     var resData = await this.$apollo.mutate({
       mutation: gqLQueryList,
       variables: {
         where_key:where ,
         offset:offset,
         limit:limit,
         orderBy:{created_at: 'desc'}
       }
     });
     var listData = resData.data[this.model.tableName];*/
      var listData = []

      /*var gqLQueryCount = DataServices.countData(this.model.tableName);
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key:where
        }
      });
      var total = countRes.data[this.model.tableName+'_aggregate']['aggregate']['count'];*/
      var total = 0;
     // var totalPoint = 0;
//console.log("this.$commonFuction.convertJsonObject(filters):",this.$commonFuction.convertJsonObject(filters))
      // console.log("filtersfilters:",filters)

      const currentTimezone = moment.tz.guess();
      const headers = {
          "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken()),
          "Timezone": currentTimezone,
      };
      this.$emit("emit_filter", dataRequest);
      this.data_filter = dataRequest;
      var list_action_detail = await ApiRepository.post('/api_admin/order/list_accident_admin', dataRequest, {headers});
      listData = list_action_detail["data"]["data"]["list_data"]
      total = list_action_detail["data"]["data"]["total"]
      const total_fee = list_action_detail["data"]["data"]["total_fee"] || 0;
      //totalPoint = list_action_detail["data"]["data"]["totalPoint"]
      var dataRes = {
        listData: listData,
        total: total,
        total_fee: total_fee,
       // total_point: totalPoint,
      };
      console.log('dataRes:',dataRes);
      return dataRes;
    },
    onLazyEvent() {
      //khi reload thì bỏ check box
      this.list_select_id = [];
      this.checkBoxAll = false;

      this.lazyParams.filters = this.filtersCustom;
      // console.log('this.lazyParams:',this.lazyParams)
      this.loading = true;
      var that =this;
      this.dataList(this.lazyParams).then(async data => {
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        var list_id = data.listData.map(item => item.id);

        const headers = {
          "Authorization": "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        console.log("headers:", headers);
        console.log("list_id:", list_id);

        // Gọi API với list_id để lấy danh sách lượt truy cập
       //var list_action_detail = await ApiRepository.post('/_api/car/count_rental_order_rent', { list_id: list_id }, { headers });
       //console.log("list_action_detail", list_action_detail);
        var list_map_id = {}
        for (var i = 0; i < data.listData.length; i++) {
          var itemData = data.listData[i]
          stt++;
          data.listData[i].stt = stt;
          data.listData[i].vehicle_category_name = itemData?.vehicle_category_name ?? '';
          data.listData[i].license_plate_number = itemData?.license_plate_number ?? '';
          data.listData[i].contact_name = itemData?.contact_name ?? '';
          data.listData[i].contact_phone = itemData?.contact_phone ?? '';

          if (data.listData[i].fee) data.listData[i].fee = '$' + parseFloat(data.listData[i].fee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00';
          else data.listData[i].fee = '$0.00';
          
          list_map_id[data.listData[i].id] = data.listData[i]
        }
        this.list_map_id = list_map_id
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        this.fixedItems[0].total = data.total;
        var total_fee = data.total_fee || 0
        this.fixedItems[1].total =   '$' + parseFloat(total_fee).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '$0.00'
        that.loading = false;
      })
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    formatDateUpdate(dateString) {
      if (!dateString) {
        return null;
        
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      return `${day}/${month}/${year} `;
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event,type_input,key){
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
.p-inputtext{
  width: 100%;
}
.p-button-label{
  color : white;
}


.box-header-table {
  margin-bottom: 16px;
  display: flex; // Sử dụng flexbox để căn chỉnh
  align-items: center; // Căn giữa theo chiều dọc
  justify-content: space-between; // Đẩy nội dung sang hai bên

  .info-box {
    display: flex; // Sử dụng flexbox để dãn đều
    align-items: center; // Căn giữa theo chiều dọc
    /* border: 1px solid #ccc;*/
    // Đường viền
    padding: 8px; // Khoảng cách bên trong
    border-radius: 5px; // Bo tròn các góc
    background: #F8F8F8 0% 0% no-repeat padding-box;
    height: 56px;
    white-space: nowrap; // Ngăn text xuống dòng
    max-width: fit-content; // Chiều rộng tối đa theo nội dung
    overflow: hidden;

    .info-image {
      width: 32px; // Chiều rộng hình ảnh
      height: 32px; // Chiều cao hình ảnh
      margin-right: 10px; // Khoảng cách giữa hình ảnh và nội dung
    }

    .info-content {
      display: flex; // Sử dụng flexbox cho nội dung
      flex-direction: row; // Căn theo chiều ngang
      align-items: center; // Căn giữa theo chiều dọc

      .info-title {
        margin: 0; // Xóa khoảng cách mặc định
        font-size: 16px; // Kích thước chữ tiêu đề
        margin-right: 5px; // Khoảng cách giữa tiêu đề và giá trị
      }

      .info-value {
        font-weight: bold; // Đậm chữ
        margin: 0; // Xóa khoảng cách mặc định
        font-size: 16px; // Kích thước chữ giá trị
        color: #555; // Màu chữ
      }
    }
  }

  .style_btn_export {
    height: 40px;
    background: #FFDF01 0% 0% no-repeat padding-box;
    border: 1px solid #FFDF01;
    border-radius: 3px;
    font: normal normal normal 16px/21px Segoe UI;
    letter-spacing: 0px;
    color: #000000;

    .p-button-label {
      color: #000000;
    }
  }

  .style_btn_export:hover {
    background: #FFDF01 0% 0% no-repeat padding-box;
    border: 1px solid #FFDF01;
  }
}
.simple-filter{
  background: transparent;
  padding: 0;
  margin-bottom: 10px;
}

.filter-left{
  display:flex;
  gap: 14px;
  align-items:flex-end;
}

.filter-item{
  display:flex;
  flex-direction:column;
  gap: 4px;
}

.filter-item label{
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.filter-item .p-calendar,
.filter-item .p-multiselect{
  width: 260px;
  height: 36px;
}

.filter-right{
  display:flex;
  align-items:flex-end;
}


</style>
<style lang="css">
.box-header-table button {
  background-color: #ffdf01;
  color: #000000;
  border: 0;
  padding: 13px 35px;
}

.box-header-table button:hover {
  background-color: #ffdf01;
  color: #000000;
  opacity: 0.8;
}

.box-header-table button:disabled {
  background-color: #f2f3f7;
  color: #666666;
}

.box-header-table .p-button:enabled:hover {
  background-color: #ffdf01;
  color: #000000;
  opacity: 0.7;
  border-color: unset;
}

.box-header-table button .p-button-label {
  color: #000000;
  font-weight: 600;
  line-height: 1;
}


</style>
